import {
  Button,
  Card,
  Grid,
  List,
  Modal,
  Toast,
  WhiteSpace,
  WingBlank,
} from "antd-mobile";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { Route } from "react-router-dom";
//   import instance from "../../../../util/axios";
//   import { Result } from "../../../../schema";
//   import DictionarySelect from "../../../../component/CheckBoxItem";

export default function TestProject() {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const [tankuang, setTankuang] = useState<{
    visible: boolean;
    rejectId?: string;
    userId?: string;
  }>({
    visible: false,
  });

  const Jump1 = () => {
    window.location.href = "/hr/maillist";
  };
  const Jump2 = () => {
    window.location.href = "/hr/myquery";
  };
  const Jump3 = () => {
    window.location.href = "/hr/jxassessment";
  };
  const Jump4 = () => {
    window.location.href = "/hr/rankadjustment";
  };
  // useEffect(() => {
  //   load();
  // }, [load]);

  return (
    <>
      <Button onClick={Jump1}>通讯录</Button>
      <Button onClick={Jump2}>我的查询</Button>
      <Button onClick={Jump3}>绩效考核</Button>
      <Button onClick={Jump4}>职级管理</Button>
    </>
  );
}
